export default __webpack_public_path__ + "static/media/pulse.3367c7cc.svg";